import { Link } from "react-router-dom";

export default function CTA() {
  return (
    <section className="cta-section">
      <div className="container">
        <div className="section-intro">
          <h2 className="cta-title">
            Ready for Professional RO Service?
          </h2>

          <p className="cta-description">
            Contact us today for reliable, expert RO solutions across Darbhanga.
          </p>
        </div>

        <div className="cta-buttons">
          <a href="tel:8863093448" className="btn btn-accent">
            <i className="fas fa-phone"></i>
            <span>+91 8863093448</span>
          </a>

          <Link to="/" className="btn btn-contact">
            <i className="fas fa-envelope"></i>
            <span>Contact Us</span>
          </Link>
        </div>
      </div>
    </section>
  );
}